import { WEB_APPS_LIST_BY_NAME } from "../../../types.js";
import { RegionViewModel } from "../../../viewmodels/RegionViewModel.js";
import { RegionItem } from "./RegionItem.js";
import { useEffect, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { useSingleton } from "mvc-kit/react";
// src/modules/AppWrapper2/components/AppNav/components/RegionPicker.tsx
function RegionPicker({ onCloseRegionPicker }) {
	const regionVM = useSingleton(RegionViewModel);
	const availableRegions = regionVM.availableRegions;
	const selectedRegions = regionVM.selectedRegions;
	const userPrimaryRegionId = regionVM.userPrimaryRegionId;
	const containerRef = useRef(null);
	const [containerHeight, setContainerHeight] = useState(window.innerHeight);
	useEffect(() => {
		const windowHeight = window.innerHeight;
		const containerTop = containerRef.current?.getBoundingClientRect().top;
		setContainerHeight(containerTop ? windowHeight - containerTop : windowHeight);
	}, [containerRef.current, window.innerHeight]);
	if (!availableRegions?.length) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: "z-dropdown bg-surface-strong p-sm overflow-y-auto rounded",
		style: { maxHeight: containerHeight },
		ref: containerRef,
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "px-xs text-color-subtle text-sm font-bold uppercase tracking-wider",
				children: "Regions"
			}),
			availableRegions.map(({ id, name, timezone }) => /* @__PURE__ */ jsx(RegionItem, {
				id,
				isActive: !!selectedRegions.find(({ id: _id }) => _id === id),
				isDisabled: regionVM.state.allowMultiRegionSelection ? selectedRegions.length === 1 && selectedRegions[0].id === id : selectedRegions[0]?.id === id,
				isPrimary: userPrimaryRegionId === id,
				name,
				onClick: () => {
					regionVM.changeRegion(id);
					onCloseRegionPicker?.();
				},
				showTimezoneTime: true,
				timezone
			}, id)),
			/* @__PURE__ */ jsxs("div", {
				className: "mt-xs border-border pt-xs text-color-subtle border-t text-xs",
				children: [
					"Primary Region can be changed from your",
					" ",
					/* @__PURE__ */ jsx("a", {
						className: "focus:text-color-main:light text-color-main hover:text-color-main-light active:text-color-main-dark transition-colors",
						href: WEB_APPS_LIST_BY_NAME.PROFILE.link,
						children: "Profile"
					}),
					"."
				]
			})
		]
	});
}
export { RegionPicker };

//# sourceMappingURL=RegionPicker.js.map